import React from 'react';
import PropTypes from 'prop-types';
import './CustomText.css';

function CustomText({
  icon: Icon,
  text,
  baseClass = 'custom-text',
  activeClass = '',
  borders = '',
  bordersClassPrefix = 'border-black-',
}) {
  // Generowanie klas dla ramek na podstawie borders
  const borderClasses = borders === '' ? '' : borders
    .split('')
    .map((char) => `${bordersClassPrefix}${char}`)
    .join(' ');

  return (
    <div 
      className={`${baseClass} ${activeClass} ${borderClasses}`}
    >
      {Icon && <Icon className="text-icon" />}
      <span className="text-content">{text}</span>
    </div>
  );
}

CustomText.propTypes = {
  icon: PropTypes.elementType, // Komponent ikony
  text: PropTypes.string.isRequired, // Tekst do wyświetlenia
  baseClass: PropTypes.string, // Klasa podstawowego wyglądu (opcjonalna, z domyślną wartością)
  hoverClass: PropTypes.string.isRequired, // Klasa dla hover
  activeClass: PropTypes.string, // Klasa dla stanu aktywnego
  borders: PropTypes.string, // Ciąg znaków definiujący ramki (np. "LRBT")
  bordersClassPrefix: PropTypes.string, // Prefiks klas dla ramek
  onClick: PropTypes.func, // Funkcja wywoływana przy kliknięciu
};

CustomText.defaultProps = {
  baseClass: 'custom-text', // Domyślna wartość dla baseClass
  borders: '', // Domyślnie brak ramek
  bordersClassPrefix: 'border-black-', // Domyślny prefiks dla klas ramek
  activeClass: '', // Domyślnie brak klasy aktywnej
  onClick: () => {}, // Domyślna pusta funkcja onClick
};

export default CustomText;